import { render, staticRenderFns } from "./VesselData.vue?vue&type=template&id=10dd1502&scoped=true"
import script from "./VesselData.vue?vue&type=script&lang=js"
export * from "./VesselData.vue?vue&type=script&lang=js"
import style0 from "./VesselData.vue?vue&type=style&index=0&id=10dd1502&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd1502",
  null
  
)

export default component.exports